import React from 'react'
import { ContainerTitle } from '../../common/container-title'
import { Grid, Paper } from '@material-ui/core'
import { FormAutocomplete, FormInputText } from '../../../dsn-kernel'
import { ChoixType } from '../ChoixType'
import { useSelector } from 'react-redux'

export const FonctionInfos = ({ classes, useFormObj, isEdit }) => {
  const { control } = useFormObj
  const fonctions = useSelector(state => state.fonctionModule.fonctions)
  const uniqueTags = new Set()
  fonctions.forEach(item => {
    item.tags.forEach(tag => {
      uniqueTags.add(tag)
    })
  })
  const uniqueTagsList = Array.from(uniqueTags)
  return (
    <Paper className={classes.contentRoot} elevation={1}>
      <ContainerTitle variant="h5" classes={classes} title="Création de fonction" />
      <Grid item xs={8}>
        <FormInputText
          label={'Nom de la fonction'}
          name="nom"
          control={control}
          rules={{ required: true }}
          disabled={isEdit}
        />
        <ChoixType classes={classes} useFormObj={useFormObj} />
        <FormAutocomplete label={'Tags'} name="tags" control={control} multiple options={uniqueTagsList} freeSolo />
        <FormInputText
          label={'Description'}
          name="description"
          control={control}
          rules={{ required: true }}
          multiline
          rows={4}
        />
        <FormInputText label={'Exemple'} name="exemple" control={control} multiline rows={4} />
      </Grid>
    </Paper>
  )
}
